declare const ScalarFresnel: any; // global constant from engine

export class ScalarFresnelModel {
  edge: number;
  center: number;
  centerBias: number;
  edgeBias: number;
  power: number;

  constructor({center = 0, edge = 1, centerBias = 1, edgeBias = 0, power = 1} = {}) {
    this.edge = edge;
    this.center = center;
    this.centerBias = centerBias;
    this.edgeBias = edgeBias;
    this.power = power;
  }

  static toEngine(scalarFresnel: ScalarFresnelModel) {
    return [scalarFresnel.center / 100, scalarFresnel.edge / 100, 
      scalarFresnel.centerBias / 100, scalarFresnel.edgeBias / 100, scalarFresnel.power];
  }
}
